import { useField } from "formik";
import { Checkbox, type CheckboxProps } from "../../ui/Checkbox/Checkbox";

type CheckboxFieldProps = { name: string; shouldValidate?: boolean } & Omit<
	CheckboxProps,
	"checked" | "onCheckedChange"
>;

export const CheckboxField = ({
	name,
	value,
	shouldValidate = false,
	...props
}: CheckboxFieldProps) => {
	const [field, meta, helpers] = useField(name);

	const currentValues = field.value;
	const checked = Array.isArray(currentValues) ? currentValues.includes(value) : !!currentValues;

	const handleCheckChange = (isChecked: boolean) => {
		helpers.setTouched(true, shouldValidate);

		if (Array.isArray(currentValues)) {
			if (isChecked) {
				helpers.setValue([...currentValues, value], shouldValidate);
			} else {
				helpers.setValue(
					currentValues.filter(item => item !== value),
					shouldValidate
				);
			}
		} else {
			helpers.setValue(!!isChecked, shouldValidate);
		}
	};

	return (
		<Checkbox
			checked={checked}
			onCheckedChange={handleCheckChange}
			error={!!meta.error && meta.touched}
			value={value}
			{...props}
		/>
	);
};
